import script from "./ChartLegendPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartLegendPanel.vue?vue&type=script&setup=true&lang=js"

import "./ChartLegendPanel.vue?vue&type=style&index=0&id=1d0ec76c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d0ec76c"]])

export default __exports__